/* @flow */

import { connect } from 'react-redux';
import TypeFieldComponent from './typeImpl';
import { SELLER_ROLE_ADMINISTRATOR, SELLER_ROLE_BASIC } from 'constants/constants';

const mapStateToProps = (state, props) => ({
  ...props,
  isLoading: state.locale.genericDataIsLoading,
  values: props.isAdministrator || (props.hasProcurationUsers && props.hasProcurationGeneralConditions) ? state.locale.rolesForSellers :
          props.hasAdministratorRole ? state.locale.rolesForSellers.filter(r => r.id !== SELLER_ROLE_BASIC) :
          props.hasProcuration ? state.locale.rolesForSellers.filter(r => r.id !== SELLER_ROLE_ADMINISTRATOR) :
          state.locale.rolesForSellers.filter(r => r.id !== SELLER_ROLE_ADMINISTRATOR && r.id !== SELLER_ROLE_BASIC)
});

export default connect(mapStateToProps)(TypeFieldComponent);
